export default [
  {
    'id': 'rock',
    'defeat': ['scissors', 'lizard']
  },
  {
    'id': 'paper',
    'defeat': ['rock', 'spock']
  },
  {
    'id': 'scissors',
    'defeat': ['paper', 'lizard']
  },
  {
    'id': 'lizard',
    'defeat': ['paper', 'spock']
  },
  {
    'id': 'spock',
    'defeat': ['rock', 'scissors']
  }
]



// WEBPACK FOOTER //
// ./src/scripts/config/b.conf.js